import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {getDaysInMonth, namesOfDays, configureMonth} from './utils';

import Day from './Day';

class Month extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      namesOfWeekDays: [],
      daysInMonth: null,
      daysInLastMonth: null,
      beginWeekDay: null,
      endWeekDate: null,
    }
  }

  static propTypes = {
    isISO: PropTypes.bool,
    locale: PropTypes.string,
    year: PropTypes.number,
    month: PropTypes.number,
    today: PropTypes.string,
    returnThisDate: PropTypes.func,
    myEvents: PropTypes.array,
    events: PropTypes.array,
  };

  static defaultProps = {
    locale: 'en',
    isISO: true,
    myEvents: [],
    events: [],
  };

  componentWillMount() {
    this.setState({
      namesOfWeekDays: namesOfDays(this.props.locale, this.props.isISO),
      daysInMonth: getDaysInMonth(this.props.year, configureMonth(this.props.month)),
      beginWeekDay: this.getBeginWeekDay(this.props.year, this.props.month),
      endWeekDate: this.getEndWeekDay(
        this.props.year, configureMonth(this.props.month), getDaysInMonth(this.props.year, configureMonth(this.props.month))
      ),
      daysInLastMonth: getDaysInMonth(this.props.year, configureMonth(this.getPrev(this.props.month))),
    })
  }

  componentWillReceiveProps(next) {
    this.setState({
      namesOfWeekDays: namesOfDays(next.locale, this.props.isISO),
      daysInMonth: getDaysInMonth(next.year, configureMonth(next.month)),
      beginWeekDay: this.getBeginWeekDay(next.year, next.month),
      endWeekDate: this.getEndWeekDay(
        next.year, configureMonth(next.month), getDaysInMonth(next.year, configureMonth(next.month))
      ),
      daysInLastMonth: getDaysInMonth(next.year, configureMonth(this.getPrev(next.month))),
    })
  }


  getEndWeekDay(year, month, day){
    if (this.props.isISO) {
      return moment(`${year}-${month}-${day}`).isoWeekday() - 1
    }
    return moment(`${year}-${month}-${day}`).weekday()
  }

  getBeginWeekDay(year, month) {
    if (this.props.isISO) {
      return moment(`${year}-${configureMonth(month)}-01`).isoWeekday() - 1
    }
    return moment(`${year}-${configureMonth(month)}-01`).weekday()
  }

  getPrev(month) {
    let result = month;
    if (month !== 0) {
      result -= 1;
    } else
      result = 11;
    return result;
  }

  renderNameWeekDays() {
    const result = [];
    for (let i = 0; i < this.state.namesOfWeekDays.length; i++) {
      result.push(
        <li
          className="calendar__week-item"
          key={`${i}_calendar_day_name`}
        >
          {this.state.namesOfWeekDays[i]}
        </li>
      );
    }
    return result;
  }

  renderDays() {
    const result = [];
    /**
     * Add days from last month */
    let countMinus = 0;
    for (let i = 0; i < this.state.beginWeekDay; i++) {
      result.unshift(
        <Day
          className="not-this-month"
          key={`${i}_calendar_day_last_month`}
          year={this.props.year}
          month={this.props.month}
          today="0T0"
          dayNumber={this.state.daysInLastMonth - countMinus}
        />
      );
      countMinus += 1;
    }
    /**
     * Create month days */
    for (let i = 1; i <= this.state.daysInMonth; i++) {
      result.push(
        <Day
          className="this-month"
          key={`${i}_calendar_day`}
          year={this.props.year}
          month={this.props.month}
          today={this.props.today}
          returnThisDate={this.props.returnThisDate}
          dayNumber={i}
          myEvents={this.props.myEvents}
          events={this.props.events}
        />
      );
    }
    /**
     * Add days at end of month */
    let countPlus = 0;
    for (let i = this.state.endWeekDate; i < 6; i++) {
      countPlus += 1;
      result.push(
        <Day
          className="not-this-month"
          key={`${i}_calendar_day_next_month`}
          year={this.props.year}
          month={this.props.month}
          today="0T0"
          dayNumber={countPlus}
        />
      );
    }

    return result;
  }

  render() {
    // console.log(this.state.beginWeekDay, this.state.endWeekDate)
    // console.log(this.state.namesOfWeekDays, this.state.daysInMonth);
    return (
      <div className="calendar__numbers">
        <ul className="calendar__week">
          {this.renderNameWeekDays()}
        </ul>
        <ul className="calendar__day">
          {this.renderDays()}
        </ul>
      </div>
    )
  }
}

export default Month;



// WEBPACK FOOTER //
// ./src/app/components/Calendar/Month.js